/**
 * ClearLineAnimator
 * Handles the explosion of tiles and falling of these above of exploded ones.
 */

export default class ClearLineAnimator {

    // ==================== Construction ====================
    constructor(game, board, bgTilesView, animsView) {
        this.game = game;
        this.board = board;

        // separate layers because bacgrodund tiles are under tiles, and animations are above tiles
        this.bgTilesView = bgTilesView;
        this.animsView = animsView;

        // we keep them here, not as a part of tile, because these are static, and tiles are falling and moving
        // so it is easier to have them in separate arrays
        this.bgTiles = [];

        // cache helpers for checking simplification
        this.rowCleared = [];
        this.colsCleared = [];
    }

    // ==================== Initialization ====================
    init() {
        this.animsView.removeAll();
        this.bgTilesView.removeAll();
        this.bgTiles.length = 0;
        this.rowCleared.length = 0;
        this.colsCleared.length = 0;

        var cols = this.board.columnsCount;
        var rows = this.board.rowsCount;
        for (var col = 0; col < cols; col++) {
            this.bgTiles[col] = [];
            for (var row = 0; row < rows; row++) {
                this.generateBgTile(col, row);
            }
        }
    }

    // ==================== Checking ====================
    checkRows() {
        for (var row = 0; row < this.board.rowsCount; row++) {
            var emptyRow = true;
            for (var col = 0; col < this.board.columnsCount; col++) {
                var tile = this.board.getTile(col, row);

                // at least one tile is still alive, so row can't be empty!
                if (tile.alive) {
                    emptyRow = false;
                    break;
                }
            }

            if (emptyRow) { this.clearRow(row); }
            // rows on the top can only be cleared, so as soon as there is one not clear, we can be sure
            // there won't be any more clear ones later
            else break;
        }
    }

    checkColumns() {
        for (var col = 0; col < this.board.columnsCount; col++) {
            var emptyCol = true;
            for (var row = 0; row < this.board.rowsCount; row++) {
                var tile = this.board.getTile(col, row);

                // at least one tile is still alive, so row can't be empty!
                if (tile.alive) {
                    emptyCol = false;
                    break;
                }
            }

            if (emptyCol) { this.clearCol(col); }
        }
    }

    // ==================== Clearing ====================
    clearRow(row) {
        if (this.rowCleared[row]) { return; }
        GS.newLineCleared();
        this.rowCleared[row] = true;

        for (var col = 0; col < this.board.columnsCount; col++) {
            // control this value to control, what delay between tiles animation occures in ms
            var delay = 50 * col;
            this.playTileClearAnim(col, row, delay);
        }
    }

    clearCol(col) {
        if (this.colsCleared[col]) { return; }
        GS.newLineCleared();
        this.colsCleared[col] = true;

        for (var row = 0; row < this.board.rowsCount; row++) {
            // control this value to control, what delay between tiles animation occures in ms
            var delay = 50 * row;
            this.playTileClearAnim(col, row, delay)
        }
    }

    playTileClearAnim(col, row, delay) {
        // here is a part responsible for animating clearing up the line
        // for tiles which were not cleared yet
        var tile = this.bgTiles[col][row];

        var anim = this.generateBgAnim(col, row, delay);

        // to make it more smooth small alpha animation is added
        anim.alpha = 0;

        this.game.add.tween(anim)
            .to({alpha: 1}, 150, window.Phaser.Easing.Linear.None, true, delay * 0.85);

        this.game.tweens.removeFrom(tile);
        this.game.add.tween(tile)
            .to({alpha: 0}, 150, window.Phaser.Easing.Linear.None, true, delay + 100);

        this.game.time.events.add(delay + 250, function () {
            tile.alpha = 0
        }, this);
    }

    // ==================== Generation ====================
    generateBgTile(col, row) {
        // return null
        var tile = PARAMS.makeSprite(this.game, 0, 0, 'gameElements', 'tileBg.png');
        tile.x = col * 47 * PARAMS.scaleFactor;
        tile.y = row * 47 * PARAMS.scaleFactor;

        this.bgTilesView.add(tile);
        this.bgTiles[col][row] = tile;
        return tile;
    }

    generateBgAnim(col, row, delay) {
        var anim = PARAMS.makeSprite(this.game, 0, 0, 'flashAnims', 'emptyLineTileAnimation/0000');
        var frames = window.Phaser.Animation.generateFrameNames('emptyLineTileAnimation/', 0, 10, '', 4);
        anim.animations.add('explode', frames, 16, false);
        anim.x = (col * 47 - 47 - 13) * PARAMS.scaleFactor;
        anim.y = (row * 47 - 47 - 13) * PARAMS.scaleFactor;
        this.animsView.add(anim);

        anim.events.onAnimationComplete.add(function () {
            this.animsView.removeChild(anim);
            anim.destroy();
            anim = null
        }, this);

        this.game.time.events.add(delay, function () {
            this.play('explode')
        }, anim);
        return anim;
    }
}
